import { render, staticRenderFns } from "./TheoryIndex.vue?vue&type=template&id=bff6d7ee&scoped=true&"
import script from "./TheoryIndex.vue?vue&type=script&lang=js&"
export * from "./TheoryIndex.vue?vue&type=script&lang=js&"
import style0 from "./TheoryIndex.vue?vue&type=style&index=0&id=bff6d7ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff6d7ee",
  null
  
)

export default component.exports